<template>
    <section id="login" ref="loginBox">
        <transition name="fade">
            <Loading v-if="isLoading" />
        </transition>
        <div class="container mt-50 mb-50">
            <div class="content">
                <h2 class="center title ">登入即可抽獎</h2>
                <transition name="fade" v-if="!isLogin">
                    <div id="EnterDiv">
                        <p class="text my-20">活動登入</p>
                        <form class="form" autocomplete="off" @submit.prevent="loginCheck">
                            <div class="inputControl mb-30">
                                <div class="inputTitle">身分證</div>
                                <div class="inputWrapper">
                                <input
                                    id="login_userID"
                                    type="password"
                                    v-model="us1"
                                    class="inputStyle"
                                    @keyup="upper"
                                    placeholder="請輸入身分證"
                                    autocomplete="new-password"
                                />
                                <div v-if="isMasked_ID" @click="toggleMask" class="eyeIcon"> <img alt="" src="../assets/close.svg"></div>
                                <div  v-else @click="toggleMask" class="eyeIcon"> <img alt="" src="../assets/open.svg"></div>
                                </div>
                            </div>
                            <div class="inputControl">
                                <birthdayChange
                                    :dateTimeProps="birthdayAll"
                                    :key="reloadYearChangeKey"
                                    @getDateTime="getBirthdayAll"
                                    ref="yearRef"
                                    nickName="loginBirthday"
                                />
                            </div>
                            <div class=" mt-50 ">
                                <button id="sendBtn" class="btn" >確定</button>
                            </div>
                        </form>
                    </div>
                </transition>
                <transition name="fade" v-else>
                    <div id="loginDiv">
                        <router-link @click="insertProfile"
                            to="/FY24_luckydraw/search"
                            class="btn goSearch"
                        >
                            確定
                        </router-link>
                        <div @click="back" id="logout">登出</div>
                    </div>
                </transition>
            </div>
        </div>
        <div class="asideBar">
            <img src="../assets/icon-plus.svg" alt="" />
            <p>完成投保</p>
            <p>好禮等你拿</p>
            <router-link :to="{ path: '/', hash: '#login' }">立即抽獎</router-link>
        </div>
    </section>
</template>
<script setup>
import {onMounted, ref, watch,defineProps} from "vue";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2";
import _ from "lodash";
import Loading from "@/components/loading.vue";
import birthdayChange from "@/components/birthdayChange.vue";
import CheckData from "@/utils/checkData";
import userStatus from "@/utils/userStatus";
import CommonApi from "@/utils/commonApi";
import { useCookies } from "vue3-cookies";

let logData = null;
const isLogin = ref(JSON.parse(sessionStorage.getItem("isLogin")));
const jwtObject = JSON.parse(localStorage.getItem("jwtInfo"));
const isLoading = ref(false);
const Select = ref(false);
const isEnter = ref(false);
const us1 = ref(""); // 身分證
const birthdayAll = ref({
    year: "",
    month: "",
    date: "",
});
// 定義 props
const props = defineProps({
    checkLogout: Boolean,
});
const yearRef = ref();
const reloadYearChangeKey = ref(0);

const route = useRoute();
const isMasked_ID = ref(true); // 隱碼狀態
const router = useRouter();
const { cookies } = useCookies();
const referrerCode = ref("");
const back = () => {
    Select.value = false;
    isEnter.value = false;
    sessionStorage.setItem("isLogin", false);
    isLogin.value = JSON.parse(sessionStorage.getItem("isLogin"));
    userStatus.logout();
};
//取得生日資料
const getBirthdayAll = (data) => {
    birthdayAll.value = data;
}


const loginCheck = () => {
    let checkFlag = true;
    let errorMsg = "";
    if(!us1.value||!CheckData.id(us1.value)){
        checkFlag = false;
        errorMsg = "請確認身分證字號";
    }
    if (!birthdayAll.value.year || !birthdayAll.value.month || !birthdayAll.value.date) {
        checkFlag = false;
        errorMsg = "請確認出生日期";
    }
    if (!checkFlag) {
        alertFunc(errorMsg, "登入錯誤", "errormark");
    } else {
        if (logData != null) {
            us1.value = logData.account;
            birthdayAll.value = logData.birthday;
            reloadYearChangeKey.value += 1;
        }
        startLogin();
    }
};

const startLogin = () => {
    isLoading.value = true;
    const logData = {
        account: us1.value,
        birthday: `${birthdayAll.value.year}-${birthdayAll.value.month}-${birthdayAll.value.date}`,
        sourceRemark: "活動-FY24",
    };
    userStatus.otpLogin(
        logData,
        (type, res) => {
            isLoading.value = false;
            res.data.type = type;
            referrerCode.value = route.query.referrerCode;
            const logDataStorage = {
                birthday:birthdayAll.value.year + '-' + birthdayAll.value.month + '-' + birthdayAll.value.date,
                sourceRemark:"活動-FY24"
            }
            sessionStorage.setItem('logData',JSON.stringify(logDataStorage));
            sessionStorage.setItem("otp", JSON.stringify(res.data));
            sessionStorage.setItem("referrerCode", referrerCode.value);

            router.push("/FY24_luckydraw/verify");
        },
        (res) => {
            alertFunc(res.message, "錯誤", "errormark");
            isLoading.value = false;
        },
        () => {
            alertFunc("登入連線錯誤", "錯誤", "errormark");
            isLoading.value = false;
        }
    );
};

const insertProfile = () => {
    const jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
    const login41 = sessionStorage.getItem("login41");
    if(jwtObject){
        const referrerCode = sessionStorage.getItem('referrerCode')
        CommonApi.insertProfile(cookies.get("fpc"), false, referrerCode, jwtInfo.token);
        if(login41){
            CommonApi.recordAction("login41", jwtInfo.token);
        }else {
            CommonApi.recordAction("sso41", jwtInfo.token);
        }
    }else {
        isLogin.value = false;
        sessionStorage.setItem("isLogin", false);
    }
}

const alertFunc = (errorTxt, errorTitle, icon,thenCallback) => {
    Swal.fire({
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: '確定',
        customClass: {
            container: "swal-S",
        },
        html: `<img src="${require('../assets/' + icon + '.svg')}" alt="Error"><div><h3 class="alertTitle">${errorTitle}</h3><p>${errorTxt}</p></div>`,
    }).then(thenCallback);
};

// 切換隱碼狀態
const toggleMask = () => {
    const loginUserID = document.getElementById("login_userID");

    let currentType = loginUserID.getAttribute("type");
    if (isMasked_ID.value || currentType === "password") {
        loginUserID.setAttribute("type", "text");
    } else {
        loginUserID.setAttribute("type", "password");
    }
    isMasked_ID.value = !isMasked_ID.value;
};

//檢查是否登入
isLogin.value = JSON.parse(sessionStorage.getItem('isLogin'));
if(jwtObject){
    Select.value = true;
    sessionStorage.setItem('isLogin', true);
    isLogin.value= ref(JSON.parse(sessionStorage.getItem('isLogin')));
}
// 檢查是否需要登出
const checkLogout = ref();
// checkLogout.value = props.checkLogout;
watch(()=>props.checkLogout, (newVal) => {
    checkLogout.value = newVal;
    if(newVal){
        back();
    }
});

//身分證大小寫
const upper = _.debounce(() => {
    if (us1.value) {
        us1.value = us1.value.toString().toUpperCase();
        us1.value = CheckData.convertToHalfWidth(us1.value);
    }
}, 50);
onMounted(() => {
    isLogin.value = JSON.parse(sessionStorage.getItem('isLogin'));
});
</script>
<style lang="scss">
#login {
    background: url("../assets/bg-login.svg");
    background-position: center bottom;
    background-color: #FFECE3;
    background-size: 25%;
    border-top: 2px solid $black;
    border-bottom: 2px solid $black;
    @media screen and (max-width: $nb) {
        background-size: 50%;
    }
    @media screen and (max-width: $mobile-small) {
        background-size: 80%;
    }
    .content {
        background: $white;
        margin: 0 auto;
        border-radius: 20px;
        text-align: center;
        padding: 30px;
        color: $blue-700;
        border:2px solid $black;
        position: relative;
        @media screen and (max-width: $mobile-small) {
            padding: 30px 20px;
        }
        .loginIcon{
            position: absolute;
            right: -10%;
            bottom: -50px;
            width: 25%;
            @media screen and (max-width: $pc) {
                width: 18%;
            }
            @media screen and (max-width: $pad) {
                width: 150px;
            }
            @media screen and (max-width: $pad) {
                width: 120px;
            }
            @media screen and (max-width: $mobile-small) {
                display: none;
            }
        }
        .text{
            color:$black;
            font-size:20px;
        }
        #selectDiv {
            padding: 5% 0 10%;
            overflow: hidden;
            @media screen and (max-width: $mobile-small) {
                padding:20px 0 50px;

            }
        }
        .form {
            max-width: 770px;
            margin: 0 auto;
        }
        .inputControl {
            display: block;
            &.one{
                width:100%
            }
            @media screen and (max-width: $pad) {
                width:100%;
            }

        }
        input{
            border: 1px solid #b2b2b2;
            width: 100%;
            height: 40px;
            padding-left: 10px;
            box-sizing: border-box;
            border-radius: 100px;
            color:$black;
            font-size: 16px;
            &:focus {
                border: 1px solid $gray-600;
                border-bottom: 2px solid $blue-700;
                outline: none;
            }
        }

        #loginDiv{
            overflow: hidden;
            padding:50px 0 100px;
            @media screen and (max-width: $mobile-small) {
                padding:20px 0;
                .btn{width:90%;display:block;margin:10px auto;box-sizing: border-box;}
            }
        }
    }
    .eyeIcon {
        position: absolute;
        right: 10px;
        cursor: pointer;
        margin-right: 10px;
        margin-top: 10px;
    }
    .inputWrapper {
        display: flex;
        align-items: center;
        position: relative;
        flex-direction: column;
    }
}
#logout {
    position: absolute;
    left: 0;
    top: 0;
    background: $pink-800;
    color: $white;
    padding: 7px 10px;
    border-top-left-radius: 20px;
    border-bottom-right-radius: 20px;
    cursor: pointer;
    &:hover{
        transition: all 200ms linear;
        background:#e44055;
    }
}
.asideBar{
    position:fixed;
    right:0;
    bottom:200px;
    z-index: 500;
    text-align: center;
    background:$blue-700;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    padding:5px 10px;
    box-sizing: border-box;
    font-weight:bold;
    color:$white;
    a{
        text-decoration: none;
    }
    @media screen and (max-width: $mobile-small) {
        font-size:12px;
        top:inherit;
        bottom:145px;
    }
    img{
        margin-top:-56px;
        width: 83px;
    }
    a{
        background:$yellow-800;
        color:$black;
        padding:2px 10px;
        margin: 10px 0;
        display: block;
        font-weight:400;
        border-radius: 18px;
    }

}
.correct {
    .swal2-show {
        background-color: #e4efe7;
        padding: 50px 0;

        &::before {
            //content: url("../assets/pop-boy.svg");
            right: -45%;
            bottom: -40%;
            position: absolute;
            @media screen and (max-width: $mobile-small) {
                display:none
            }
        }
    }
    .swal2-html-container {
        font-weight: bold;
    }
    .swal2-title {
        color: $blue-700;
    }
    .award {
        padding: 10px 20px;
        box-sizing: border-box;
        border: 2px solid $blue-700;
        background: $white;
        display: inline-block;
        border-radius: 10px;
        color: $blue-700;
        margin: 5px auto;
    }
}

</style>
